var map = {
	"./bootstrap.png": 60,
	"./c.png": 61,
	"./css3.png": 62,
	"./es6.png": 63,
	"./express.png": 64,
	"./firebase.png": 65,
	"./github.png": 66,
	"./heroku.png": 67,
	"./html5.png": 68,
	"./jira.png": 69,
	"./js.png": 70,
	"./material.png": 71,
	"./miro.png": 72,
	"./mongodb.png": 73,
	"./next.png": 74,
	"./node.png": 75,
	"./php.png": 76,
	"./python.png": 77,
	"./react.png": 78,
	"./redux.png": 79,
	"./sass.png": 80,
	"./slack.png": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;